import { TimeManagementListItem } from '@myapp/contract'

export function isMidnightScheduledDate(iso: string): boolean {
  const d = new Date(iso)
  return d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0
}

export function getHourFromIso(iso: string): number {
  const d = new Date(iso)
  return d.getUTCHours() + d.getUTCMinutes() / 60
}

export function formatTimeHHmm(iso: string): string {
  const d = new Date(iso)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export function hasAllDayTMEntry(entries: TimeManagementListItem[], dayIso: string): boolean {
  return entries.some((e) => {
    const start = new Date(e.startTime)
    const end = new Date(e.endTime)
    return (
      start.toISOString().slice(0, 10) <= dayIso &&
      start.getHours() === 0 &&
      start.getMinutes() === 0 &&
      end.toISOString().slice(0, 10) >= dayIso &&
      end.getHours() >= 23
    )
  })
}
